/* eslint-disable @typescript-eslint/no-unused-vars */
import classNames from 'classnames';
import { PersonProps } from 'Components/common/components/PeopleCardLarge';
import { useRef } from 'react';
import { useDrop } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { actions as groupActions } from 'Slice/GroupsSlice';
import { GroupsProps } from './GroupsDisplayWidget';

type Props = {
  children: JSX.Element
  newGroup?: boolean
  groupCategory?: string
  groupStage?: string
  addPersonGroup?: (a: GroupsProps, b: PersonProps) => void
  createNewGroup?: (a: PersonProps) => void
  addReasonPopup?: (a: PersonProps, b: string, c: string) => void
} & typeof defaultProps;
const defaultProps = {
  newGroup: false,
  groupCategory: '',
  groupStage: '',
  addPersonGroup(a: GroupsProps, b: PersonProps) { },
  createNewGroup(a: PersonProps) { },
  addReasonPopup(a: PersonProps, b: string, c: string) { },
};
const DropWrapper = function DropWrapper(props: Props) {
  const {
    addPersonGroup, createNewGroup, addReasonPopup, children, newGroup, groupCategory, groupStage,
  } = props;
  const dispatch = useDispatch();

  const latest = useRef({
    childProps: children.props as GroupsProps,
    addPersonGroup,
    createNewGroup,
    addReasonPopup,
  });
  latest.current = {
    childProps: children.props as GroupsProps,
    addPersonGroup,
    createNewGroup,
    addReasonPopup,
  };

  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: 'PEOPLE',
      collect: (monitor) => ({
        isOver: monitor.isOver(),
      }),
      drop(item) {
        dispatch(groupActions.setDropComplete(true));
        if (!newGroup) {
          latest.current.addPersonGroup(latest.current.childProps, item as PersonProps);
        } else {
          latest.current.createNewGroup(item as PersonProps);
        }
        if (groupCategory && groupStage) {
          latest.current.addReasonPopup(item as PersonProps, groupCategory, groupStage);
        }
      },
    }),
    [groupCategory, groupStage, newGroup],
  );

  return (
    <div ref={drop} className={classNames('drop-person-area', { activeDrop: isOver })}>
      {children || null}
    </div>
  );
};
DropWrapper.defaultProps = defaultProps;
export default DropWrapper;
